import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

type OptimizedMegaMenuDropdownVar = {
  selectedL1CategoryName: string;
  isOptimizedMegaMenuOpen: boolean;
};

const INITIAL_STATE: OptimizedMegaMenuDropdownVar = {
  selectedL1CategoryName: "",
  isOptimizedMegaMenuOpen: false,
};

const optimizedMegaMenuDropdownVar: ReactiveVar<OptimizedMegaMenuDropdownVar> = makeFSVar(
  INITIAL_STATE,
  "useOptimizedMegaMenuDropdownVar"
);

const resetOptimizedMegaMenuDropdown = () => {
  optimizedMegaMenuDropdownVar(INITIAL_STATE);
};

const setSelectedMegaMenuL1Category = (
  selectedL1CategoryName: OptimizedMegaMenuDropdownVar["selectedL1CategoryName"],
  isOptimizedMegaMenuOpen: OptimizedMegaMenuDropdownVar["isOptimizedMegaMenuOpen"]
) => {
  optimizedMegaMenuDropdownVar({
    ...optimizedMegaMenuDropdownVar(),
    selectedL1CategoryName,
    isOptimizedMegaMenuOpen,
  });
};

const useOptimizedMegaMenuDropdownVar = (): OptimizedMegaMenuDropdownVar => {
  return useReactiveVar(optimizedMegaMenuDropdownVar);
};

export {
  useOptimizedMegaMenuDropdownVar,
  setSelectedMegaMenuL1Category,
  resetOptimizedMegaMenuDropdown,
  optimizedMegaMenuDropdownVar,
};
